import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Events from '../pages/Events';
import FormSubscriber from '../pages/FormSubscriber';
import IndividualSubscriber from '../pages/FormSubscriber/IndividualSubscriber';
import AutoSubscribe from '../pages/FormSubscriber/AutoSubscribe';
import CompanySubscribe from '../pages/FormSubscriber/CompanySubscribe';
import EventDetails from '../pages/EventDetails';
import EventDetailsCustom from '../pages/EventDetailsCustom';
import Contact from '../pages/Contact';
import Documents from '../pages/Documents';
import CheckinEvent from '../pages/Checkin';
import OldEvents from '../pages/OldEvents';
import ManagerUpdater from '../utils/ManagerUpdater';
import BoletoItau from '../pages/EventDetails/boleto';
import Programacao from '../pages/EventDetails/Programacao';
import SortionSubscriber from '../pages/SortionSubscriber';
import Recibo from '../pages/Recibo';
import Recipe from '../pages/Recipe';
import Certificates from '../pages/Certificates';
import Affiliate from '../pages/Affiliate';
import AffiliateCertificate from '../pages/AffiliateCertificate';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import SubscriptionPolicy from '../pages/SubscriptionPolicy';
import CheckoutSuccess from '../pages/Checkout/CheckoutSuccess';
import CheckoutCancel from '../pages/Checkout/CheckoutCancel';
import CheckoutExpired from '../pages/Checkout/CheckoutExpired';
import FlowGuard from '../pages/FormSubscriber/FlowGuard';

export const Rotas = () => {
  const allowedPaths = ["", "apeprev","semper"];
  const currentBase = window.location.pathname.split('/')[1];

  const baseName = allowedPaths.includes(currentBase) ? `/${currentBase}` : "/";


  return (
    <BrowserRouter basename={baseName}>
      <ManagerUpdater />
      <Routes>
          <Route index element={<Events />} />
          <Route path="subscribe">
            <Route path=":eventId" element={<FlowGuard expectedFlow="company"><FormSubscriber /></FlowGuard>} />
          </Route>
          <Route path="individual-subscriber">
            <Route path=":eventId" element={<FlowGuard expectedFlow="subscriber"><IndividualSubscriber /></FlowGuard>} />
          </Route>
          <Route path="auto-subscribe">
            <Route path=":eventId" element={<FlowGuard expectedFlow="auto"><AutoSubscribe /></FlowGuard>} />
          </Route>
          <Route path="company-subscribe">
            <Route path=":eventId" element={<FlowGuard expectedFlow="company"><CompanySubscribe /></FlowGuard>} />
          </Route>
          <Route path="event">
            <Route path=":eventId" element={<EventDetails />} />
            <Route path=":eventId/programacao" element={<Programacao />} />
          </Route>
          <Route path="event-custom">
            <Route path=":eventId" element={<EventDetailsCustom />} />
          </Route>
            
          <Route path="boleto">
            <Route path=":externalId" element={<BoletoItau />} />
          </Route>
          <Route path="recibo">
            <Route path=":externalId" element={<Recibo />} />
          </Route>
          <Route path="checkin" >
            <Route path=":eventId" element={<CheckinEvent />} />
          </Route>
          <Route path="checkout" >
            <Route path=":eventId" element={<CheckinEvent />} />
          </Route>
          <Route path="sorteio" >
            <Route path=":eventId" element={<SortionSubscriber />} />
          </Route>
          <Route path="contact"  element={<Contact />} />
          <Route path="documents"  element={<Documents />} />
          <Route path="filiese"  element={<Affiliate />} />
          <Route path="eventos-anteriores"  element={<OldEvents />} />
          <Route path="recipe" element={<Recipe />} />
          <Route path="certificates" element={<Certificates />} />
          <Route path="affiliate-certificate" element={<AffiliateCertificate />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="subscription-policy" element={<SubscriptionPolicy />} />
          <Route path="checkout">
            <Route path="success" element={<CheckoutSuccess />} />
            <Route path="cancel" element={<CheckoutCancel />} />
            <Route path="expired" element={<CheckoutExpired />} />
          </Route>
      </Routes>
    </BrowserRouter>
  )
};